<p tabindex="0" [innerHtml]="'Preferences:ConfirmationMessage' | translate: { artist_name: artistName }"></p>

<div class="header d-flex">
  <ten-dummy-follow-button [isActive]="true" aria-hidden="true" class="dummy-follow-button"></ten-dummy-follow-button>

  <button
    mat-icon-button
    class="close"
    tabindex="0"
    role="button"
    aria-label="close"
    mat-dialog-close
    (keydown.enter)="$event.preventDefault()"
    (keyup.enter)="close()"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
